import { render, staticRenderFns } from "./ProfileStatus.vue?vue&type=template&id=5064f179&scoped=true&"
import script from "./ProfileStatus.vue?vue&type=script&lang=js&"
export * from "./ProfileStatus.vue?vue&type=script&lang=js&"
import style0 from "./ProfileStatus.vue?vue&type=style&index=0&id=5064f179&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5064f179",
  null
  
)

export default component.exports